import { useEffect, useState } from "react";
import Label from "../../c-organism/titleBar/Label";
import Button from "../buttons/Button";
import style from "./ListItem.module.css";
import Icon from "../../a-atoms/icons/Icon";
import bkLogo from "../../../assets/brands/bk.png";
import ssbLogo from "../../../assets/brands/ssb.png";

const ListItem = (props) => {
  const [labels, setLabels] = useState([]);

  function onClickHandler(i) {
    props.onClick(i);
  }

  useEffect(() => {
    let tempLabels = [];
    for (let i in props.data.labels) {
      tempLabels.push({
        id: i,
        ...props.data.labels[i],
      });
    }
    setLabels(tempLabels);
  }, [props.modified]);

  function getScoreClass(score) {
    if (score === null || score === undefined) return "";
    if (score >= 80) return style.scoreExcellent;
    if (score >= 60) return style.scoreGood;
    if (score >= 40) return style.scoreOK;
    return style.scorePoor;
  }

  function renderNameWithLogos(name) {
    if (!name) {
      return null;
    }

    const parts = name.split(/(\[BK\]|\[SSB\]|\[NG\]|\[ZA\]|\[ZM\])/g);

    return parts.map((part, index) => {
      if (part === "[BK]") {
        return (
          <img
            key={`bk-${index}`}
            src={bkLogo}
            alt="BK"
            className={style.brandIcon}
          />
        );
      }
      if (part === "[SSB]") {
        return (
          <img
            key={`ssb-${index}`}
            src={ssbLogo}
            alt="SSB"
            className={style.brandIcon}
          />
        );
      }
      if (part === "[NG]") {
        return (
          <span key={`ng-${index}`} className={style.flagIcon}>
            🇳🇬
          </span>
        );
      }
      if (part === "[ZA]") {
        return (
          <span key={`za-${index}`} className={style.flagIcon}>
            🇿🇦
          </span>
        );
      }
      if (part === "[ZM]") {
        return (
          <span key={`zm-${index}`} className={style.flagIcon}>
            🇿🇲
          </span>
        );
      }
      if (!part) {
        return null;
      }
      return (
        <span key={`text-${index}`}>
          {part}
        </span>
      );
    });
  }

  return (
    <div
      className={style.listItem}
      onClick={() => onClickHandler(props.data.id)}
    >
      <div>
        <div className={style.name}>{renderNameWithLogos(props.data.name)}</div>
      </div>
      <div className={style.right}>
        <div>
          {labels &&
            labels.map((label, index) => (
              <Label
                key={index}
                selected={label.selected}
                modified={props.modified}
                data={label}
              >
                {label.value}
              </Label>
            ))}
        </div>
        {props.data.owners && props.data.owners.length > 0 && (
          <div className={style.owners}>
            {props.data.owners.map((owner, index) => (
              <div
                key={`owner-${owner.uid || index}`}
                className={style.ownerAvatar}
                title={owner.name || owner.email || "Owner"}
                style={
                  owner.photoURL
                    ? {
                        backgroundImage: `url(${owner.photoURL})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        color: "transparent",
                      }
                    : {}
                }
              >
                {!owner.photoURL && owner.initials}
              </div>
            ))}
          </div>
        )}
        <div className={`${style.sus}`}>
          {props.data.journeyScore !== null && props.data.journeyScore !== undefined ? (
            <span className={getScoreClass(props.data.journeyScore)}>{Math.round(props.data.journeyScore)}%</span>
          ) : null}
        </div>
        <div className={style.actions}>
          {/* <Button variants={["text", "small"]}>View</Button> */}
          <Icon>chevron_right</Icon>
        </div>
      </div>
    </div>
  );
};

export default ListItem;
